/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S5_HeadingInputs */

const tr_hakkimizda_s5_heading = /** @type {(inputs: Hakkimizda_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İletişim`)
};

const en_hakkimizda_s5_heading = /** @type {(inputs: Hakkimizda_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const de_hakkimizda_s5_heading = /** @type {(inputs: Hakkimizda_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const ru_hakkimizda_s5_heading = /** @type {(inputs: Hakkimizda_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контакты`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Hakkimizda_S5_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s5_heading = /** @type {((inputs?: Hakkimizda_S5_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S5_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s5_heading(inputs)
	if (locale === "de") return de_hakkimizda_s5_heading(inputs)
	if (locale === "ru") return ru_hakkimizda_s5_heading(inputs)
	return tr_hakkimizda_s5_heading(inputs)
});